import React from 'react';
import cn from 'class-names';

import UserLinks from '@components/UserLinks/UserLinks';
import HelpButton from '@components/HelpButton/HelpButton';

import { isStandaloneMode } from '@constants/app-modes';
import { isConciergeRealm } from '@utils/realmIdentifier';
import SidebarFooterProfile from '../SidebarFooterProfile/SidebarFooterProfile';

import './SidebarFooter.scss';

function SidebarFooter(): JSX.Element {
  const cnSidebarFooter = cn('sidebar-footer', {
    'sidebar-footer--concierge': isConciergeRealm(),
  });

  return (
    <div className={cnSidebarFooter}>
      <UserLinks />
      {isStandaloneMode() && (isConciergeRealm() ? <SidebarFooterProfile /> : <HelpButton />)}
      {isStandaloneMode() && !isConciergeRealm() && <SidebarFooterProfile />}
    </div>
  );
}

export default SidebarFooter;
